import React from "react";
import { SettingsScreenContainer } from "src/containers";

export const SettingsScreen = () => {
  return <SettingsScreenContainer />;
};
